import VueAutocomplete from "./VueAutocomplete";

export default {
    install(Vue) {
        Vue.component("VueAutocomplete", VueAutocomplete);
    }
};